import React, { useState } from 'react';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import { Box, Menu, MenuItem, MenuList, Paper } from '@mui/material';
import {
  FlagIcon,
  HighPriorityIcon,
  LowPriorityIcon,
  MediumPriorityIcon,
  UrgentPriorityIcon,
} from '@components';

import { styles } from './setPriority.style';

export const PRIORITIES = [
  {
    label: 'No priority',
    value: 0,
    icon: <MoreHorizIcon data-testid="MoreHorizIcon" />,
  },
  {
    label: 'Urgent',
    value: 1,
    icon: <UrgentPriorityIcon />,
  },
  {
    label: 'High',
    value: 2,
    icon: <HighPriorityIcon />,
  },
  {
    label: 'Medium',
    value: 3,
    icon: <MediumPriorityIcon />,
  },
  {
    label: 'Low',
    value: 4,
    icon: <LowPriorityIcon />,
  },
];

const SetPriority = ({ onSetPriority }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (priority) => {
    if (onSetPriority) {
      onSetPriority(priority);
    }
    handleMenuClose();
  };

  return (
    <>
      <Box sx={styles.wrapper} onClick={handleOpenMenu}>
        <Box sx={styles.button}>
          <FlagIcon />
          <Box sx={styles.text}>Set Priority</Box>
        </Box>
      </Box>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={styles.menu}
      >
        <Paper sx={styles.paper}>
          <MenuList sx={styles.menuList}>
            {PRIORITIES?.map((item) => {
              return (
                <MenuItem
                  key={`priority-${item.value}`}
                  disabled={item?.disabled}
                  onClick={() => handleClick(item.value)}
                  sx={styles.menuItem}
                >
                  {item.icon} {item.label}
                </MenuItem>
              );
            })}
          </MenuList>
        </Paper>
      </Menu>
    </>
  );
};

export default SetPriority;
